import React from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import useAuth from "../../hooks/useAuth";

const roleBadgeColors = {
  platform_admin: "bg-indigo-100 text-indigo-700",
  tenant_admin: "bg-emerald-100 text-emerald-700",
  support_agent: "bg-amber-100 text-amber-700",
  viewer: "bg-slate-100 text-slate-600",
};

const Topbar = ({ title, subtitle, onMobileToggle, mobileOpen }) => {
  const { user } = useAuth();
  const role = user?.role || "viewer";
  const badgeColor = roleBadgeColors[role] || roleBadgeColors.viewer;

  return (
    <div className="flex md:hidden items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 py-3 sm:px-6 sm:py-3.5">
      <div className="flex items-center gap-2.5 min-w-0">
        {onMobileToggle && (
          <button
            type="button"
            onClick={onMobileToggle}
            className="md:hidden flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 shadow-sm hover:bg-slate-50 transition shrink-0"
            aria-label={mobileOpen ? "Close sidebar menu" : "Open sidebar menu"}
          >
            {mobileOpen ? <X size={16} /> : <Menu size={16} />}
          </button>
        )}
        {title ? (
          <div className="min-w-0">
            <h2 className="text-base sm:text-lg font-semibold text-slate-950 truncate">{title}</h2>
            {subtitle ? <p className="text-xs sm:text-sm text-slate-500 truncate">{subtitle}</p> : null}
          </div>
        ) : null}
        {user?.roleLabel ? (
          <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold shrink-0 ${badgeColor}`}>
            {user.roleLabel}
          </span>
        ) : null}
      </div>
      <Link
        to="/home"
        className="inline-flex items-center justify-center rounded-xl border border-slate-200 px-3.5 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-semibold text-slate-700 transition hover:bg-slate-50 shrink-0"
      >
        Back to site
      </Link>
    </div>
  );
};

export default Topbar;
